import React, { Component } from 'react'
import Icon from "../common/icon/icon.component.jsx";

class CreditMemoTypeIcon extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            type: this.props.value || '',
            className: this.props.className || '',
            icon: this.props.icon || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            type: nextProps.value || '',
            className: nextProps.className || '',
        })
    }

    componentDidMount() { }

    getCreditMemoTypeIcon() {
        switch (this.state.type) {
            case 'deposit': return 'coins'
            case 'return': return 'undo'
            default: return 'piggy-bank'
        }
    }

    render() {
        if (this.state.icon) {
            return <Icon className={this.state.className} value={this.state.icon} />
        }
        return <Icon className={this.state.className} value={this.getCreditMemoTypeIcon()} />
    }

}

export default CreditMemoTypeIcon





// WEBPACK FOOTER //
// ./src/invoice/creditmemotypeicon.component.jsx